
webpack.register(
    'components/timeline/card-options/card-options',
    function() {
        return require('components/timeline/card-options/card-options');
    },
    false
);
webpack.register(
    'components/card/trending/trending',
    function() {
        return require('components/card/trending/trending');
    },
    false
);
webpack.register(
    'components/card/external-link/external-link',
    function() {
        return require('components/card/external-link/external-link');
    },
    false
);
webpack.register(
    'components/card/article/article',
    function() {
        return require('components/card/article/article');
    },
    false
);
webpack.register(
    'components/card/info/info',
    function() {
        return require('components/card/info/info');
    },
    false
);
webpack.register(
    'components/card/photo/photo',
    function() {
        return require('components/card/photo/photo');
    },
    false
);
webpack.register(
    'components/card/social/social',
    function() {
        return require('components/card/social/social');
    },
    false
);
webpack.register(
    'components/card/video/video',
    function() {
        return require('components/card/video/video');
    },
    false
);
webpack.register(
    'components/card/live-video/live-video',
    function() {
        return require('components/card/live-video/live-video');
    },
    false
);
webpack.register(
    'components/card/win-probability/win-probability',
    function() {
        return require('components/card/win-probability/win-probability');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/timeline/card-options/card-options\"/>\r\n\r\n<can-import from=\"components/card/trending/trending\"/>\r\n<can-import from=\"components/card/external-link/external-link\"/>\r\n<can-import from=\"components/card/article/article\"/>\r\n<can-import from=\"components/card/info/info\"/>\r\n<can-import from=\"components/card/photo/photo\"/>\r\n<can-import from=\"components/card/social/social\"/>\r\n<can-import from=\"components/card/video/video\"/>\r\n<can-import from=\"components/card/live-video/live-video\"/>\r\n<can-import from=\"components/card/win-probability/win-probability\"/>\r\n\r\n<card-options\r\n    {type}=\"type\"\r\n    {network}=\"network\"\r\n    {isPinned}=\"isPinned\"\r\n    date=\"{{date}}\">\r\n</card-options>\r\n\r\n{{#switch type}}\r\n\r\n    {{#case \"trendingCard\"}}\r\n        <card-trending {^closed}=\"closed\" card-index=\"{{cardIndex}}\" ($click)=\"onClick()\"></card-trending>\r\n    {{/case}}\r\n\r\n    {{#case \"linkCard\"}}\r\n        <card-external-link card-index=\"{{cardIndex}}\" ($click)=\"onClick()\"></card-external-link>\r\n    {{/case}}\r\n\r\n    {{#case \"infoCard\"}}\r\n        <card-info card-index=\"{{cardIndex}}\" ($click)=\"onClick()\"></card-info>\r\n    {{/case}}\r\n\r\n    {{#case \"articleCard\"}}\r\n        <card-article card-index=\"{{cardIndex}}\" ($click)=\"onClick()\"></card-article>\r\n    {{/case}}\r\n\r\n    {{#case \"photoCard\"}}\r\n        <card-photo card-index=\"{{cardIndex}}\" {gallery}=\"card.gallery\" {tags}=\"card.tags\" ($click)=\"onClick()\"></card-photo>\r\n    {{/case}}\r\n\r\n    {{#case \"socialCard\"}}\r\n        <card-social card-index=\"{{cardIndex}}\" ($click)=\"onClick()\"></card-social>\r\n    {{/case}}\r\n\r\n    {{#case \"videoCard\"}}\r\n        <card-video {card}=\"card\" {(active-card)}=\"activeCard\" {(active-card-index)}=\"activeCardIndex\" {(players-list)}=\"playersList\" card-index=\"{{cardIndex}}\" ($click)=\"onClick()\"></card-video>\r\n    {{/case}}\r\n\r\n    {{#case \"liveVideo\"}}\r\n        <card-live-video {card}=\"card\" {(active-card)}=\"activeCard\" {(active-card-index)}=\"activeCardIndex\" {(players-list)}=\"playersList\" {(is-ad-finished)}=\"isAdFinished\" card-index=\"{{cardIndex}}\" ($click)=\"onClick()\"></card-live-video>\r\n    {{/case}}\r\n\r\n    {{#case \"winProbabilityCard\"}}\r\n        <card-win-probability {card}=\"card\" {(active-card)}=\"activeCard\" {(active-card-index)}=\"activeCardIndex\" {(players-list)}=\"playersList\" {(is-ad-finished)}=\"isAdFinished\" card-index=\"{{cardIndex}}\"></card-win-probability>\r\n    {{/case}}\r\n\r\n{{/switch}}\r\n");